<nz-card
  nzHoverable
  class="p-3 w-full min-h-[150px]"
>
  <div class="flex items-center gap-2 mb-2">
    <div class="rounded flex items-center justify-center w-6 h-6 {{ card.color }}">
      <img [src]="card.icon" [alt]="card.title" />
    </div>
    <span class="text-sm">{{ card.title }}</span>
  </div>

  <span class="text-[32px] font-medium text-[#333333]">
    <ng-container *ngIf="card.isCurrency; else nonCurrency">
      {{ card.value | currency : "IDR" : "symbol" : "1.0-0" }}
    </ng-container>
    <ng-template #nonCurrency>
      {{ card.fraction ? card.value + '/' + card.fraction : card.value }}
    </ng-template>
  </span>

  <div *ngIf="card.footer" class="flex flex-wrap gap-1 mt-3">
    <small class="text-gray-400">{{ card.footer.label }}</small>
    <ng-container *ngIf="card.footer.isCurrency; else defaultFooter">
      <small>{{ card.footer.value | currency : "IDR" : "symbol" : "1.0-0" }}</small>
    </ng-container>
    <ng-template #defaultFooter>
      <small>{{ card.footer.value }}</small>
    </ng-template>
  </div>
</nz-card>
